import React, { useState } from "react";
import { KeyRound, Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../api";

const errText = (d) => (typeof d === "string" ? d : Array.isArray(d) ? d.map((e) => e.msg).join(" ") : "Something went wrong");

const Field = ({ label, testId, value, onChange }) => (
  <div className="mb-4">
    <label className="mb-1 block font-display text-xs font-semibold uppercase tracking-wider text-[#2D6A4F]">{label}</label>
    <input type="password" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}
      className="w-full rounded-xl border border-[#d6e6dc] px-4 py-3 outline-none focus:border-[#2D6A4F]" />
  </div>
);

const AdminSettings = () => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 8 || !/\d/.test(next)) return setError("New password must be at least 8 characters and include a number");
    if (next !== confirm) return setError("New passwords don't match");
    setBusy(true);
    try {
      const r = await api.post("/auth/change-password", { current_password: current, new_password: next });
      localStorage.setItem("bs_admin_token", r.data.token);
      setCurrent(""); setNext(""); setConfirm("");
      toast.success("Password updated. Other devices have been logged out.");
    } catch (err) {
      setError(errText(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="p-6 lg:p-8" data-testid="admin-settings-page">
      <h1 className="font-display text-3xl font-bold uppercase text-[#1B2a21]">Settings</h1>
      <p className="mb-5 text-[#6b7d72]">Keep your admin panel secure</p>
      <form onSubmit={submit} className="max-w-md rounded-2xl border border-[#e6f0ea] bg-white p-5" data-testid="change-password-form">
        <div className="mb-4 flex items-center gap-2"><KeyRound size={18} className="text-[#2D6A4F]" /><h2 className="font-display text-lg font-bold uppercase text-[#1B2a21]">Change Password</h2></div>
        <Field label="Current password" testId="current-password-input" value={current} onChange={setCurrent} />
        <Field label="New password" testId="new-password-input" value={next} onChange={setNext} />
        <Field label="Confirm new password" testId="confirm-password-input" value={confirm} onChange={setConfirm} />
        <p className="mb-4 flex items-center gap-1.5 text-xs text-[#6b7d72]"><ShieldCheck size={14} /> At least 8 characters with a number. All other devices will be logged out.</p>
        {error && <p className="mb-4 rounded-xl bg-[#fdecec] px-4 py-2 text-sm text-[#b42318]" data-testid="change-password-error">{error}</p>}
        <button type="submit" disabled={busy || !current || !next || !confirm} data-testid="change-password-submit"
          className="flex w-full items-center justify-center gap-2 rounded-full bg-[#2D6A4F] py-3 font-display text-sm font-bold uppercase tracking-wide text-white transition-colors hover:bg-[#1B4332] disabled:opacity-50">
          {busy && <Loader2 size={16} className="animate-spin" />} Update Password
        </button>
      </form>
    </div>
  );
};

export default AdminSettings;
